import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ClausesDirectory from "@/pages/ClausesDirectory";
import EmploymentHub from "@/pages/EmploymentHub";
import BusinessHub from "@/pages/BusinessHub";
import FixedTermEmployment from "@/pages/FixedTermEmployment";
import TerminationForCause from "@/pages/TerminationForCause";
import IndemnityClause from "@/pages/IndemnityClause";
import NoticePeriod from "@/pages/NoticePeriod";
import CancellationClause from "@/pages/CancellationClause";
import NonCompeteClause from "@/pages/NonCompeteClause";
import ProbationPeriod from "@/pages/ProbationPeriod";
import PaymentInLieuOfNotice from "@/pages/PaymentInLieuOfNotice";
import RestraintOfTrade from "@/pages/RestraintOfTrade";
import ConfidentialityClause from "@/pages/ConfidentialityClause";
import IntellectualPropertyClause from "@/pages/IntellectualPropertyClause";
import ForceMajeureClause from "@/pages/ForceMajeureClause";
import LimitationOfLiability from "@/pages/LimitationOfLiability";
import VariationClause from "@/pages/VariationClause";
import GoverningLawClause from "@/pages/GoverningLawClause";
import RedundancyClause from "@/pages/RedundancyClause";
import LeaveEntitlementsClause from "@/pages/LeaveEntitlementsClause";
import ScopeOfWorkClause from "@/pages/ScopeOfWorkClause";
import TerminationForConvenience from "@/pages/TerminationForConvenience";
import PaymentTermsClause from "@/pages/PaymentTermsClause";
import DisputeResolutionClause from "@/pages/DisputeResolutionClause";
import WarrantiesAndRepresentations from "@/pages/WarrantiesAndRepresentations";
import Sitemap from "@/pages/Sitemap";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/clauses" element={<ClausesDirectory />} />
          <Route path="/clauses/employment" element={<EmploymentHub />} />
          <Route path="/clauses/business" element={<BusinessHub />} />
          <Route path="/explain-fixed-term-employment-clause" element={<FixedTermEmployment />} />
          <Route path="/explain-termination-for-cause-clause" element={<TerminationForCause />} />
          <Route path="/explain-indemnity-clause" element={<IndemnityClause />} />
          <Route path="/explain-notice-period-clause" element={<NoticePeriod />} />
          <Route path="/explain-cancellation-clause" element={<CancellationClause />} />
          <Route path="/explain-non-compete-clause" element={<NonCompeteClause />} />
          <Route path="/explain-probation-period-clause" element={<ProbationPeriod />} />
          <Route path="/explain-payment-in-lieu-of-notice-clause" element={<PaymentInLieuOfNotice />} />
          <Route path="/explain-restraint-of-trade-clause" element={<RestraintOfTrade />} />
          <Route path="/explain-confidentiality-clause" element={<ConfidentialityClause />} />
          <Route path="/explain-intellectual-property-clause" element={<IntellectualPropertyClause />} />
          <Route path="/explain-force-majeure-clause" element={<ForceMajeureClause />} />
          <Route path="/explain-limitation-of-liability-clause" element={<LimitationOfLiability />} />
          <Route path="/explain-variation-clause" element={<VariationClause />} />
          <Route path="/explain-governing-law-clause" element={<GoverningLawClause />} />
          <Route path="/explain-redundancy-clause" element={<RedundancyClause />} />
          <Route path="/explain-leave-entitlements-clause" element={<LeaveEntitlementsClause />} />
          <Route path="/explain-scope-of-work-clause" element={<ScopeOfWorkClause />} />
          <Route path="/explain-termination-for-convenience-clause" element={<TerminationForConvenience />} />
          <Route path="/explain-payment-terms-clause" element={<PaymentTermsClause />} />
          <Route path="/explain-dispute-resolution-clause" element={<DisputeResolutionClause />} />
          <Route path="/explain-warranties-and-representations" element={<WarrantiesAndRepresentations />} />
          <Route path="/sitemap.xml" element={<Sitemap />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
